const kollectAiDashboard = {
  dashboardProtfolio: '/kollectai/api/v1/dashboard/portfolio-overview',
};

export default kollectAiDashboard;
